import { Map } from 'immutable'
import {
  NOTIFICATION_MODAL,
  REDIRECT_MODAL,
  URL_COPY_MODAL,
} from './Modals'

export const ADD_MODAL = 'ADD_MODAL'
export const REMOVE_MODAL = 'REMOVE_MODAL'

export function displayRedirectModal(itemId) {
  return addModal(REDIRECT_MODAL, Map({
    itemId,
  }))
}

export function displayNotificationModal(message, title) {
  return addModal(NOTIFICATION_MODAL, Map({
    message: message,
    title: title,
  }))
}

export function displayUrlCopyModal(url, title) {
  return addModal(URL_COPY_MODAL, Map({
    url: url,
    title: title,
  }))
}

function addModal(modalId, modalData) {
  return (dispatch) => {
    dispatch({
      type: ADD_MODAL,
      modalId,
      modalData,
    })
  }
}

export function removeModal(modalId) {
  return (dispatch) => {
    dispatch({
      type: REMOVE_MODAL,
      modalId,
    })
  }
}
